import checkout from "./form2";

const {
  formField2: {
    quarter,
    year,
    name,
    taxId
  },
} = checkout;

const initialValues2 = {
  [quarter.name]: "",
  [year.name]: "",
  [name.name]: "",
  [taxId.name]: "",
};

export default initialValues2;
